import { render } from "./ProductSearchBar.vue?vue&type=template&id=24ed9aca&scoped=true"
import script from "./ProductSearchBar.vue?vue&type=script&lang=js"
export * from "./ProductSearchBar.vue?vue&type=script&lang=js"

import "./ProductSearchBar.vue?vue&type=style&index=0&id=24ed9aca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24ed9aca"

export default script